// extracted by mini-css-extract-plugin
export default {"container":"Searchbar_container__YJQIw"};